import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as Filters from "../ts/rlAdmin.filters";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { SearchService } from "../services/search-service";

export function RLInventoryQuickSearch() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/inventory-quick-search.html"),
        scope: {
            selected: "=ngModel",
            selectedIp: "=?selectedIp",
            singleSelect: "=?singleSelect",
            selectedTitle: "=?selectedTitle",
            selectedSearchDocs: "=?selectedSearchDocs"
        },
        controller: RLInventoryQuickSearchController,
        bindToController: true,
        controllerAs: "iqsVM"
    };
    return directive;
}

interface IRLInventoryQuickSearch extends ng.IScope {
    selected: { [key: number]: boolean };
    singleSelect: boolean;
    selectedIp: number;
    selectedTitle: string;
    templateGroupIDs: number[];
    selectedSearchDocs: Models.IEntitySearchDoc[];
}

class RLInventoryQuickSearchController {
    static $inject = ["$scope", "$filter", "notifyService", "eventService", "searchService"];

    keywords: string;
    itemRows: Models.IEntitySearchDoc[];
    page: number;
    pageCount: number;
    rowCount: number;
    qTime: number;
    jumpTo: number;
    selectedStatus: string;
    selectedTemplate: string;
    templates: Models.IKeyValuePair<string, number>[];
    templateFacets: Models.IKeyValuePair<string, string>[];
    statuses: Models.IKeyValuePair<string, number>[];
    statusFacets: Models.IKeyValuePair<string, string>[];
    sortField: string;
    sortDir: number;
    initialized: boolean;
    numFound: number;
    selectAll: boolean;
    resetSelectAll: boolean;
    selected: { [key: number]: boolean };
    selectedSearchDocs: Models.IEntitySearchDoc[];
    selectedIp: number;
    selectedTitle: string;
    rawBulkIds: string;
    bulkError: boolean;

    constructor(private $scope: IRLInventoryQuickSearch, private $filter: ng.IFilterService, private notifyService: NotifyService, private eventService: EventService, private searchService: SearchService) {
        this.keywords = "";			// keyswords 
        this.itemRows = [];			// search result item rows
        this.page = 1;				// current page
        this.pageCount = 1;			// current page	count of search	results
        this.rowCount = 10;
        this.qTime = 0;				// time	in ms of search	operation
        this.jumpTo = 1;				// jump-to input value
        this.selectedStatus = null;		// current selected	status
        this.selectedTemplate = null;	// current selected	template
        this.templates = [];			// template	data for select	box
        this.statuses = [];			// status data for select box
        this.sortField = "";			// sort by field (matches a solr field)
        this.sortDir = 0;				// sort by direction.  0 - asc, 1 - desc
        this.initialized = false;
        this.selected = {};		// Inventories checked on search	results
        this.selectedSearchDocs = [];
        this.selectAll = false;
        this.resetSelectAll = false;

        $scope.$watch(() => this.selectedTemplate, (newValue: string, oldValue: string) => {
            if (newValue != oldValue) {
                this.selectedStatus = null;
            }
        });

        $scope.$watch(() => [this.selectedStatus, this.selectedTemplate],
            (newValue: any[], oldValue: any[]) => {
                this.page = 1;
            }, true);

        $scope.$watch(() => [this.selectedStatus, this.selectedTemplate, this.page, this.sortDir, this.sortField],
            (newValue: any[], oldValue: any[]) => {
                this.Search();
            }, true);

        $scope.$watch(() => this.templates,
            (newValue: Models.IKeyValuePair<string, number>[], oldValue: Models.IKeyValuePair<string, number>[]) => {
                if (newValue != oldValue) {
                    this.templateFacets = $filter<Filters.IFacetFilter>("facetFilter")(newValue);
                }
            }, true);

        $scope.$watch(() => this.statuses,
            (newValue: Models.IKeyValuePair<string, number>[], oldValue: Models.IKeyValuePair<string, number>[]) => {
                if (newValue != oldValue) {
                    this.statusFacets = $filter<Filters.IFacetFilter>("facetFilter")(newValue);
                }
            }, true);

        $scope.$watch(() => this.selectAll, (newValue: boolean, oldValue: boolean) => {
            if (newValue != oldValue) {
                if (newValue) {
                    this.SelectAll();
                }
                else {
                    if (!this.resetSelectAll) {
                        this.SelectNone();
                    }
                    //this.SelectNone();
                }
            }
        });

        $scope.$watch(() => this.selected, (newValue, oldValue) => {
            var count = 0;
            for (var i in newValue) {
                var key = _.parseInt(i);
                if (newValue[key]) {
                    this.itemRows.forEach((item: Models.IEntitySearchDoc) => {
                        if (item.recordID == key) {
                            count++;
                            if (!_.contains(this.selectedSearchDocs, item)) {
                                this.selectedSearchDocs.push(item);
                            }
                        }
                    });
                }
            }
            if (count != this.itemRows.length) {
                this.resetSelectAll = true;
                this.selectAll = false;
            }
            else {
                this.resetSelectAll = false;
                this.selectAll = true;
            }
        }, true);
    }

    // calls a search using	current	state data
    Search() {
        this.notifyService.startProgress();

        var req: Models.IAdvancedSearchModel = {
            charTypeID: Consts.CharTypeIDs.inventory,
            searchGroups: [],
            keywords: this.keywords || "",
            template: this.selectedTemplate || "",
            status: this.selectedStatus || "",
            page: this.page || 1,
            rowCount: this.rowCount,
            sortField: this.sortField || "",
            sortDir: this.sortDir || 0,
            templateGroupIDs: [],
            active: true
        }

        this.searchService.advancedSearch(req)
            .then((result) => {
                this.itemRows = result.documents;
                this.qTime = result.qTime;
                this.numFound = result.numFound;
                this.pageCount = Math.ceil(result.numFound / this.rowCount);
                this.templateFacets = result.getTemplateFacets();
                this.statusFacets = result.getStatusFacets();
                this.jumpTo = this.page;
                this.initialized = true;
                this.resetSelectAll = false;
                this.selectAll = false;
                this.SetupSelectAll();
            })
            .finally(() => {
                this.initialized = true;
                this.notifyService.endProgress();
            });
    }

    // fired when search button	is clicked
    SearchClick($event: ng.IAngularEvent) {
        this.page = 1;				// reset page
        this.Search();				// push	state
        $event.preventDefault();		// cancel button click
    }

    Select(assetID: number, title: string) {
        this.selectedIp = assetID;
        this.selectedTitle = title;
    }

    SelectAll() {
        this.itemRows.forEach((item: Models.IEntitySearchDoc) => {
            this.selected[item.recordID] = true;
        });
    }

    SelectNone() {
        //this.$scope.selected = {};
        this.itemRows.forEach((item: Models.IEntitySearchDoc) => {
            this.selected[item.recordID] = false;
        });
    }

    SetupSelectAll() {
        var count = 0;
        this.itemRows.forEach((item: Models.IEntitySearchDoc) => {
            if (this.selected[item.recordID]) {
                count++;
            }
            if (count == this.itemRows.length) {
                this.selectAll = true;
            }
        });
    }

    ValidateBulkIds() {
        // reset bulk error flag
        this.bulkError = false;
        this.$scope.selected = {};

        if (this.rawBulkIds) {
            var bulkIds = this.rawBulkIds.split(',');

            if (bulkIds.length > 0) {
                _.forEach(bulkIds, (item) => {
                    var inventoryID = parseInt(item);
                    if (!inventoryID) {
                        this.bulkError = true;
                        this.selected = {};
                        return;
                    }
                    this.selected[+item] = true;
                });
            }
        }
    }
}
